import { Box, Button, FormHelperText, InputAdornment, Link, OutlinedInput, Paper, Typography } from "@mui/material";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import * as propTypes from 'prop-types';
import { findSymbol, formatNumber, getSymbol } from "../../../../utils";
import { useSelector } from "react-redux";
export default function Step1({ dashboardData, amount, handleActive, active, handleAmountChange, errors }) {
    const { t } = useTranslation();
    const symbols = useSelector(getSymbol);
    const account = useSelector(({ Auth }) => Auth?.account);
    const helperRef = useRef();
    const handleChange = (val) => {
        let err = { amount: "" };
        helperRef.current.style.color = '#F8FAFF';
        if (
            parseFloat(val.toString()) > parseFloat(dashboardData.balance.toString())
        ) {
            err = {
                amount: t("err.lowBalance"),
            };
        }
        if (parseFloat(val.toString()) <  dashboardData.payoutMinimumTransferable) {
            helperRef.current.style.color = '#DC2626';
        }
        if (/^\d+(\.\d{0,2})?$/.test(val) || val === '') {
            handleAmountChange(val, err);
        }
    }
    function inpNum(e) {
        e = e || window.event;
        var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        if (charCode === 8 || charCode === 190) {
            return;
          }        
        var charStr = String.fromCharCode(charCode);
        if (!charStr.match(/^[0-9]+$/))
          e.preventDefault();
      }
    return (
        <Paper
            sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                maxHeight: "50vh",
            }}
        >
            <Box display={"flex"} alignItems="center">
                <Typography fontSize={14} fontWeight={400} color="#D4D4D8">
                    {t("balance")}&nbsp;:&nbsp;
                </Typography>
                <Typography fontSize={18} fontWeight={400} color="#D4D4D8">
                    {findSymbol(symbols, account)} {formatNumber(dashboardData.balance)}
                </Typography>
            </Box>

            <Box sx={{ display: "flex", flexFlow: "row", marginTop: 1 }}>
                <OutlinedInput
                    autoFocus={true}
                    size="sm"
                    sx={{ fontSize: 30 }}
                    fullWidth
                    type="number"
                    value={amount}
                    autoComplete="off"
                    onKeyDownCapture={inpNum}
                    onKeyDown={(event) => {
                        const key = event.key.toLowerCase();
                        if (key === "enter") {
                            handleActive(active + 1);
                        }
                    }}
                    name="amount"
                    onChange={(ev) => {
                        handleChange(ev.target.value);
                    }}
                    onBlur={(ev) => {
                        ev.preventDefault();
                        handleChange(ev.target.value);
                    }}
                    error={!!errors.amount}
                    endAdornment={
                        <InputAdornment position="end">
                            <Link
                                fontSize={16}
                                fontWeight={600}
                                color="#0088F5"
                                sx={{
                                    cursor: "pointer",
                                }}
                                onClick={() =>
                                    handleChange(dashboardData.balance)
                                }
                            >
                                {t("fillWithMax")}
                            </Link>
                        </InputAdornment>
                    }
                />
            </Box>
            <Box sx={{ display: "block" }}>
                <FormHelperText
                    ref={helperRef}
                    sx={{ fontSize: 14, fontWeight: 400, textAlign: 'left', color: '#F8FAFF' }}>
                   {t('minTransferAmount')} = {findSymbol(symbols, account)}{dashboardData.payoutMinimumTransferable}
                </FormHelperText>
            </Box>
            <Box sx={{ display: "block" }}>
                <FormHelperText
                    sx={{ color: "#DC2626", fontSize: 14, fontWeight: 400, textAlign: 'left' }}>
                    {errors && errors.amount && errors.amount}
                </FormHelperText>
            </Box>
            <Button
                variant="contained"
                size="large"
                color="primary"
                sx={{
                    color: "#041939",
                    marginTop: 1,
                    fontSize: 16,
                    width: "100%",
                    textTransform: "capitalize",
                    borderRadius: "8px",
                    ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
                }}
                onClick={() => handleActive(active + 1)}
            >
                {t("nextStep")}
            </Button>
        </Paper>
    )
}

Step1.propTypes = {
    dashboardData: propTypes.any,
    amount: propTypes.any,
    handleActive: propTypes.func,
    active: propTypes.number,
    handleAmountChange: propTypes.func,
    errors: propTypes.any
}